import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('pitchpal_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('pitchpal_token');
      localStorage.removeItem('pitchpal_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const authApi = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  verify2FA: (data) => api.post('/auth/verify-2fa', data),
  resend2FA: (data) => api.post('/auth/resend-2fa', data),
  forgotPassword: (data) => api.post('/auth/forgot-password', data),
  resetPassword: (data) => api.post('/auth/reset-password', data),
  getMe: () => api.get('/auth/me'),
  toggle2FA: () => api.post('/auth/toggle-2fa'),
  recoveryReset: (data) => api.post('/auth/recovery-reset', data),
  regenerateRecoveryKey: () => api.post('/auth/regenerate-recovery-key'),
};

// Templates
export const templatesApi = {
  getAll: (params) => api.get('/templates', { params }),
  getById: (id) => api.get(`/templates/${id}`),
  download: (id, format) => api.post(`/templates/${id}/download`, { template_id: id, format }),
};

// Categories
export const categoriesApi = {
  getAll: () => api.get('/categories'),
};

// Favorites
export const favoritesApi = {
  getAll: () => api.get('/favorites'),
  add: (templateId) => api.post('/favorites', { template_id: templateId }),
  remove: (templateId) => api.delete(`/favorites/${templateId}`),
};

// Downloads
export const downloadsApi = {
  getHistory: () => api.get('/downloads'),
};

// Stats
export const statsApi = {
  get: () => api.get('/stats'),
};

// Design Sharing
export const shareApi = {
  createShare: (data) => api.post('/design/share', data),
  getMyShares: () => api.get('/design/my-shares'),
  revokeShare: (shareId) => api.delete(`/design/share/${shareId}`),
  getSharedDesign: (shareId) => api.get(`/shared/${shareId}`),
};

// Notifications
export const notificationsApi = {
  getAll: () => api.get('/notifications'),
  markRead: (id) => api.post(`/notifications/read/${id}`),
  markAllRead: () => api.post('/notifications/read-all'),
};

// Subscriptions
export const subscriptionsApi = {
  cancel: () => api.post('/subscriptions/cancel'),
};

// Feedback
export const feedbackApi = {
  submit: (data) => api.post('/feedback', data),
  getAll: () => api.get('/admin/feedback'),
  update: (id, data) => api.put(`/admin/feedback/${id}`, null, { params: data }),
};

export default api;
